import { Container } from "@mui/material";
import { NavLink } from "react-router-dom";
import PageNotFound from "../assets/svgs/404.svg";
import { ContentWrapper, HomeButton, NotFoundImage, PageContainer, Title } from "../styles/NotFoundPage";


const NotFoundPage = (props: any) => {

  return (
    <PageContainer>
      <Container maxWidth="xs">
        <ContentWrapper>
          <NotFoundImage 
            src={PageNotFound} 
            alt="404 - Page Not Found" 
          />
          <Title>
            We're sorry. Page Not Found.
          </Title>
          <NavLink to="/home" className="textdeco-none">
            <HomeButton>
              Home Page
            </HomeButton>
          </NavLink>
        </ContentWrapper>
      </Container>
    </PageContainer>
  );
};


export default NotFoundPage;
